import React from "react";
import { makeStyles } from "@material-ui/styles";
import UncontrolledLottie from "./UncontrolledLottie";
import Grid from "@material-ui/core/Grid";

const useStylesStageTwo = makeStyles((theme) => ({
/*   avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    borderRadius: "12px",
    marginRight: theme.spacing(2),
  }, */
}));



const StageTwo = (props) => {
  const classes = useStylesStageTwo();
  const {onAction} = props
  return (
    <Grid onClick={() => onAction("stageThree")} container direction="column" className="lotties">
      <UncontrolledLottie />
    </Grid>
  );
};

export default StageTwo;
